/* V3 Warenkorb (03.11.2026, Figma «Ideen – Warenkorb» 16:2): Upgrade-Knopf (snippets/v3-cart-upgrade.liquid).
   Klick: fehlende Menge derselben Variante per /cart/add.js dazulegen, danach den Paketcode-Abgleich
   (window.P5PackSync, assets/period5-pack-codes.js) sofort laufen lassen, damit Summe und Code ohne Wartezeit stimmen.
   Drawer: Inhalt über Dawns renderContents ersetzen, cartUpdate melden (period5-cart.js, Pack-Sync hören mit).
   /cart: nach dem Abgleich neu laden (Dawns Tabelle, Summe und Hinweis aus einem Guss). Keine eigenen Rabattcodes. */
(function () {
  if (window.V3CartUpgrade) return;
  window.V3CartUpgrade = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var addUrl = ((window.routes && window.routes.cart_add_url) || root + 'cart/add') + '.js';
  var track = function (n, p) {
    try { if (window.P5 && window.P5.track) window.P5.track(n, p); } catch (e) {}
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-v3up-accept]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('loading');
    var drawer = btn.closest('cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.variant), quantity: Number(btn.dataset.qty) || 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    var fail = function () {
      btn.disabled = false;
      btn.classList.remove('loading');
      var box = document.getElementById(drawer ? 'CartDrawer-CartErrors' : 'cart-errors');
      if (box) box.textContent = (window.cartStrings && window.cartStrings.error) || '';
    };
    var sync = function () {
      return window.P5PackSync ? window.P5PackSync().catch(function () {}) : Promise.resolve();
    };
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.text().then(function (t) {
          var res = null;
          try { res = JSON.parse(t); } catch (x) {}
          if (!r.ok || !res || res.status) throw new Error('add ' + r.status);
          return res;
        });
      })
      .then(function (res) {
        var price = Number(btn.dataset.price) || 0;
        var qty = Number(btn.dataset.qty) || 1;
        track('cart_upsell_accept', {
          source: 'cart_upgrade',
          target_quantity: Number(btn.dataset.target) || undefined,
          ecommerce: { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined, value: price * qty, items: [{ item_id: btn.dataset.sku || btn.dataset.variant, item_name: btn.dataset.title, price: price, quantity: qty }] }
        });
        if (drawer) {
          if (drawer.renderContents && res.sections) drawer.renderContents(res);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'v3-upgrade', cartData: res });
          return sync();
        }
        return sync().then(function () { window.location.reload(); });
      })
      .catch(fail);
  });
})();
